// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yzefan{display:block;width:100%;height:100%}.yzefan img{max-width:var(--wix-img-max-width, 100%)}.yzefan[data-animate-blur] img{filter:blur(9px);transition:filter .8s ease-in}.yzefan[data-animate-blur] img[data-load-done]{filter:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `yzefan`
};
export default ___CSS_LOADER_EXPORT___;
